import React, { Fragment } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import { buildPath, packClasses } from "Util";

export default function Pagination(props) {
    const flipperClasses =
        "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50";

    const activeClasses =
        "z-0 border-gray-300 text-green-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium";
    const defaultClasses =
        "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium";

    const clickHandler = (meta, e) => {
        if (props.onClick) {
            props.onClick(meta);
        }
    };

    const variants = {
        sm: "px-2 py-2 text-sm font-medium",
        xs: "p-1 text-xs font-medium",
    };
    const variant = props.variant ? props.variant : "sm";

    if (!props.total_pages) {
        return (
            <div className="items-center justify-between">
                <div className="flex flex-1 justify-between">
                    <div className="mx-auto h-8 w-1/2 rounded-md bg-gray-200">
                        &nbsp;
                    </div>
                </div>
            </div>
        );
    }

    let max = props.total_pages;
    let start = 1;
    if (max > 10) {
        if (props.current_page > 6) {
            start = props.current_page - 5;
        }

        max = start + 10;
        if (props.total_pages <= 10 || max > props.total_pages) {
            max = props.total_pages;
        }
    }

    const pages = [];
    for (let i = start; i <= max; i++) {
        if (props.basePath) {
            pages.push(
                <Link
                    key={"page".concat(i)}
                    to={buildPath(props.basePath, { page: i }, true)}
                    aria-current={props.current_page === i ? "page" : ""}
                    className={
                        props.current_page === i
                            ? activeClasses
                            : defaultClasses
                    }
                >
                    {i}
                    <span
                        aria-hidden="true"
                        className={packClasses(
                            props.current_page === i
                                ? "bg-green-500"
                                : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                    />
                </Link>
            );
        } else {
            pages.push(
                <span
                    key={"page".concat(i)}
                    onClick={clickHandler.bind(null, { page: i })}
                    aria-current={props.current_page === i ? "page" : ""}
                    className={packClasses(
                        "cursor-pointer",
                        props.current_page === i
                            ? activeClasses
                            : defaultClasses
                    )}
                >
                    {i}
                    <span
                        aria-hidden="true"
                        className={packClasses(
                            props.current_page === i
                                ? "bg-green-500"
                                : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                    />
                </span>
            );
        }
    }

    return (
        <div className=" flex items-center justify-between">
            <div className="flex flex-1 justify-between sm:hidden">
                {props.current_page > 1 ? (
                    <Fragment>
                        {props.basePath ? (
                            <Link
                                to={buildPath(
                                    props.basePath,
                                    {
                                        page: props.current_page - 1,
                                    },
                                    true
                                )}
                                className={flipperClasses}
                            >
                                Previous
                            </Link>
                        ) : (
                            <span
                                onClick={clickHandler.bind(null, {
                                    page: props.current_page - 1,
                                })}
                                className={packClasses(
                                    "cursor-pointer",
                                    flipperClasses
                                )}
                            >
                                Previous
                            </span>
                        )}
                    </Fragment>
                ) : (
                    <span className={flipperClasses}>Previous</span>
                )}

                {props.current_page < props.total_pages ? (
                    <Fragment>
                        {props.basePath ? (
                            <Link
                                to={buildPath(
                                    props.basePath,
                                    {
                                        page: props.current_page + 1,
                                    },
                                    true
                                )}
                                className={packClasses("ml-3", flipperClasses)}
                            >
                                Next
                            </Link>
                        ) : (
                            <span
                                onClick={clickHandler.bind(null, {
                                    page: props.current_page + 1,
                                })}
                                className={packClasses(
                                    "ml-3 cursor-pointer",
                                    flipperClasses
                                )}
                            >
                                Next
                            </span>
                        )}
                    </Fragment>
                ) : (
                    <span className={packClasses("ml-3", flipperClasses)}>
                        Next
                    </span>
                )}
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div className="mx-auto">
                    <nav
                        className="relative z-0 inline-flex -space-x-px rounded-md shadow-sm"
                        aria-label="Pagination"
                    >
                        {props.current_page > 1 ? (
                            <Fragment>
                                {props.basePath ? (
                                    <Link
                                        to={buildPath(
                                            props.basePath,
                                            {
                                                page: props.current_page - 1,
                                            },
                                            true
                                        )}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white  text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">
                                            Previous
                                        </span>
                                        <ChevronLeftIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </Link>
                                ) : (
                                    <span
                                        onClick={clickHandler.bind(null, {
                                            page: props.current_page - 1,
                                        })}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex cursor-pointer items-center rounded-l-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">
                                            Previous
                                        </span>
                                        <ChevronLeftIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            <span
                                className={packClasses(
                                    variants[variant],
                                    "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white text-gray-300 hover:bg-gray-50"
                                )}
                            >
                                <span className="sr-only">Previous</span>
                                <ChevronLeftIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                />
                            </span>
                        )}

                        {!props.paginationStyle ||
                        props.paginationStyle !== "lr-only"
                            ? pages
                            : null}

                        {props.current_page < props.total_pages ? (
                            <Fragment>
                                {props.basePath ? (
                                    <Link
                                        to={buildPath(
                                            props.basePath,
                                            {
                                                page: props.current_page + 1,
                                            },
                                            true
                                        )}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white  text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">Next</span>
                                        <ChevronRightIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </Link>
                                ) : (
                                    <span
                                        onClick={clickHandler.bind(null, {
                                            page: props.current_page + 1,
                                        })}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex cursor-pointer items-center rounded-r-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">Next</span>
                                        <ChevronRightIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            <span
                                className={packClasses(
                                    variants[variant],
                                    "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white text-gray-300 hover:bg-gray-50"
                                )}
                            >
                                <span className="sr-only">Next</span>
                                <ChevronRightIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                />
                            </span>
                        )}
                    </nav>
                </div>
            </div>
        </div>
    );
}
